namespace $ {
	/** Pinned js-yaml 4.1.1, MIT. JSON schema: no custom executable YAML types. */
	export class $shm_hitalama_skills_yaml extends $mol_object {
		static library() { return require( '../shm/hitalama/skills/yaml/_index.js' ) || ( globalThis as any ).jsyaml }
		static read( text: string ) {
			const match = /^---\r?\n([\s\S]*?)\r?\n---(?:\r?\n|$)/.exec( text )
			if( !match ) throw new Error( 'В начале SKILL.md нужен YAML-блок с name и description между строками ---.' )
			if( match[1].length > 16384 ) throw new Error( 'Заголовок SKILL.md слишком большой.' )
			const yaml = this.library()
			const data = yaml.load( match[1], { schema: yaml.JSON_SCHEMA } )
			if( !data || typeof data !== 'object' || Array.isArray( data ) ) throw new Error( 'Некорректный заголовок SKILL.md.' )
			return { data, body: text.slice( match[0].length ) }
		}
		static parse( text: string ) {
			const { data, body } = this.read( text )
			if( typeof data.name !== 'string' || !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test( data.name ) || data.name.length > 64 ) throw new Error( 'name: до 64 строчных латинских букв, цифр и дефисов.' )
			if( typeof data.description !== 'string' || !data.description.trim() || data.description.length > 1024 ) throw new Error( 'Заполните description: когда агенту применять этот скилл (до 1024 символов).' )
			return { data, body, name: data.name as string, description: data.description as string }
		}
		static update( text: string, name: string, description: string ) {
			const match = /^---\r?\n([\s\S]*?)\r?\n---(?:\r?\n|$)/.exec( text ), yaml = this.library()
			const data = match ? yaml.load( match[1], { schema: yaml.JSON_SCHEMA } ) : {}
			return '---\n' + yaml.dump( { ...data, name, description }, { schema: yaml.JSON_SCHEMA, lineWidth: -1, noRefs: true } ).trimEnd() + '\n---\n\n' + ( match ? text.slice( match[0].length ).replace( /^\n/, '' ) : text )
		}
		static with_body( text: string, body: string ) {
			const match = /^---\r?\n[\s\S]*?\r?\n---(?:\r?\n|$)/.exec( text )
			// Only the instruction changes: preserve metadata, including unknown keys.
			return match ? text.slice( 0, match[0].length ).replace( /\r?\n$/, '' ) + '\n\n' + body : body
		}
		static path( path: string ) {
			if( !path || path.length > 240 || path.includes( '\\' ) || /[\u0000-\u001f]/.test( path ) || path.split( '/' ).some( part => !part || part === '.' || part === '..' || part.startsWith( '.' ) ) || path.startsWith( '/' ) ) throw new Error( 'Укажите относительный путь внутри пакета, без .. и скрытых файлов.' )
			return path
		}
	}
}
